import { Container, OutsideClickHandler, Overlay, Spacer, TextField, Typography } from '@cleartrip/ct-design-components'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'

import Clevertap from '@/analytics/clevertap/index'
import ModifySearchCross from '@/assets/icons/ModifySearchCross'
import Calendar from '@/components/oldComponents/DateRangePicker/Calendar/Calendar'
import { DropdownMenu } from '@/components/oldComponents/Dropdown'
import { HOME_API_ENDPOINTS, REQUEST_METHODS } from '@/constants/network'
import baseFetch from '@/network/baseFetch'
import { getPartnerId } from '@/utils/cfw'
import { isEmpty } from '@/utils/general/browserHelper'
import { dateToEpoch, getFormattedDate, getInitialMonthRange, getNumberOfDaysBetweenRange } from '@/utils/general/date'
import { PE_SRP_GLASS_FIELD_CSS } from '@/constants/flights/premiumEconomy'

const CalendarWrapper = props => {
    const isRtl = process.env.CONTENT_DIR === 'RTL'
    const {
        roundTrip,
        onwardJourny = '',
        returnJourny = '',
        departDate,
        returnDate,
        dateClick,
        searchParams,
        isMulticity = false,
        fromDate,
        index = 1,
        multiCityDestinations = {},
        fromCode = '',
        toCode = '',
        onReturnCrossClick = () => {},
        showDateFare = true,
        isCFW = false,
        isThemed = false,
        fieldWidth = 155,
        gapClassName = 'ml-3',
        textVariant = '',
        fieldCss = {}
    } = props
    const glassFieldCss = isThemed ? PE_SRP_GLASS_FIELD_CSS : {}
    const dateformatOptions = { weekday: 'short', month: 'short', day: 'numeric' }
    const [activeOnward, setActiveOnward] = useState(false)
    const [activeReturn, setActiveReturn] = useState(false)
    const [openCalendar, setOpenCalendar] = useState(false)
    const [isRoundTrip, setIsRoundTrip] = useState(roundTrip)
    const [fareCalendar, setfareCalendar] = useState({})
    const [flexiData, setFlexiData] = useState({})
    const formDate = departDate ? new Date(getFormattedDate(departDate, 'MM/DD/YYYY', 'DD/MM/YYYY')) : new Date()
    const toDate = returnDate ? new Date(getFormattedDate(returnDate, 'MM/DD/YYYY', 'DD/MM/YYYY')) : ''
    const [range, setRange] = useState({ from: formDate, to: toDate, enteredTo: toDate })
    useEffect(() => {
        setIsRoundTrip(roundTrip)
        if (!roundTrip) {
            setRange({
                ...range,
                to: null,
                enteredTo: null
            })
        } else {
            if (searchParams.return_date)
                setRange({
                    ...range,
                    to: toDate,
                    enteredTo: toDate
                })
        }
    }, [activeReturn, roundTrip])

    const getDateRangePrice = async (departRange, roundtrip = false) => {
        if (!showDateFare) return
        const perAdultSearchParams = {
            ...searchParams
        }
        perAdultSearchParams.adults = 1
        perAdultSearchParams.childs = 0
        perAdultSearchParams.infants = 0
        const [startDateStr] = departRange.split('_')
        const fareCalendarPayload = {
            fareCalendarType: 'CHEAPEST',
            departDetails: !roundtrip
                ? {
                      from: !isEmpty(fromCode) ? fromCode : searchParams?.from,
                      to: !isEmpty(toCode) ? toCode : searchParams?.to,
                      startDate: dateToEpoch(startDateStr)
                  }
                : {
                      from: !isEmpty(toCode) ? toCode : searchParams?.to,
                      to: !isEmpty(fromCode) ? fromCode : searchParams?.from,
                      startDate: dateToEpoch(startDateStr)
                  },
            paxDetails: {
                adult: searchParams?.adults || 1,
                child: searchParams?.childs || 0,
                infant: searchParams?.infants || 0
            },
            fareDetails: {
                domain: 'IN',
                cabinType: searchParams.class?.toUpperCase() === 'PREMIUM ECONOMY' ? 'PREMIUM_ECONOMY' : searchParams.class?.toUpperCase() || 'ECONOMY',
                fareType: isCFW ? 'CFW' : 'RETAIL',
                fareGroup: searchParams.sft?.toUpperCase() || 'REGULAR',
                partnerId: getPartnerId(isCFW) || '10000000'
            },
            numberOfDays: getNumberOfDaysBetweenRange(departRange),
            journeyType: !roundtrip ? 'ONE_WAY' : 'ROUND_TRIP',
            departDate: !roundtrip ? '' : dateToEpoch(departDate)
        }

        const response = await baseFetch({
            body: JSON.stringify(fareCalendarPayload),
            url: HOME_API_ENDPOINTS.DATE_TABS,
            method: REQUEST_METHODS.POST
        })
        const newResponse = response?.dayData ?? []
        const hasDayData = newResponse.length > 0
        const temp = hasDayData
            ? newResponse.map(day => ({
                  pr: day.farePresent ? Number(day.amount) : '-',
                  date: day.date,
                  isCheapest: day.fareCategory === 'CHEAPEST'
              }))
            : []
        setFlexiData(prev => ({
            onward: temp,
            ...(roundtrip && { return: temp })
        }))
    }
    useEffect(() => {
        if (!isEmpty(flexiData)) {
            const flexiSearchData = { ...flexiData }
            if (!isEmpty(flexiSearchData)) {
                setfareCalendar(reformFareCalResponse(flexiSearchData))
            }
        }
    }, [flexiData])

    function handleOnwardClick() {
        getDateRangePrice(getInitialMonthRange(isMulticity ? fromDate : departDate))
        setActiveOnward(!activeOnward)
        setActiveReturn(false)
        if (openCalendar && !activeReturn) {
            setOpenCalendar(!openCalendar)
        } else {
            Clevertap.event('Air_UI_Action', {
                action_type: 'BUTTON',
                action_name: 'SRP_OW_Calendar_Opened'
            })
            setOpenCalendar(true)
        }
    }

    function handleReturnClick() {
        const _departDate = dayjs(departDate, 'DD-MM-YYYY').format('DD-MM-YYYY')
        const nextMonth = dayjs(dayjs(departDate, 'DD-MM-YYYY').add(1, 'month')).endOf('month').format('DD-MM-YYYY')
        getDateRangePrice(`${_departDate}_${nextMonth}`, true)
        setActiveOnward(false)
        setActiveReturn(!activeReturn)
        // setfareCalendar({})
        if (openCalendar && !activeOnward) {
            setOpenCalendar(!openCalendar)
        } else {
            // getDateRangePrice(getInitialMonthRange(isMulticity ? fromDate : departDate), true)
            Clevertap.event('Air_UI_Action', {
                action_type: 'BUTTON',
                action_name: 'SRP_RT_Calendar_Opened'
            })
            setOpenCalendar(true)
        }
    }

    function directionClick(departRange) {
        getDateRangePrice(departRange)
    }

    function formatDate(date) {
        if (date) {
            return getFormattedDate(date, 'ddd, MMM D')
        }
    }

    function setDates(dates) {
        setRange({ ...range, ...dates })
        dateClick(dates, range)
        if (isRoundTrip && dates['to']) {
            setOpenCalendar(false)
            setActiveOnward(false)
            setActiveReturn(false)
        }
        if (isRoundTrip && dates['from']) {
            setActiveOnward(false)
            handleReturnClick()
        } else {
            setOpenCalendar(false)
            setActiveOnward(false)
            setActiveReturn(false)
        }
    }

    function outsideCalendar() {
        setOpenCalendar(false)
        setActiveReturn(false)
        setActiveOnward(false)
    }

    function reformFareCalResponse(response) {
        const onward = {}
        const cheapFare = {}
        if (response.onward) {
            response.onward.forEach(elem => {
                onward[elem.date] = elem
                const fullMonth = getFormattedDate(elem.date, 'DD-MMMM-YYYY', 'DD/MM/YYYY')
                const month = fullMonth.split('-')[1]
                const curPrice = elem.pr || '-'
                if (cheapFare[month]) {
                    if (parseInt(cheapFare[month], 10) > parseInt(curPrice, 10) && curPrice !== '-') {
                        cheapFare[month] = curPrice
                    }
                } else if (curPrice !== '-') {
                    cheapFare[month] = curPrice
                }
            })
        }
        return { ...response, onward, cheapFare }
    }

    const resetReturn = e => {
        e.stopPropagation()
        onReturnCrossClick()
    }

    const returnCrossJsx = (
        <Container className="c-poiner" style={{ height: '16px' }} onClick={resetReturn}>
            <ModifySearchCross />
        </Container>
    )
    return (
        <OutsideClickHandler onOutsideClick={() => outsideCalendar()}>
            <div className="flex flex-middle p-relative">
                <TextField
                    name="from"
                    placeholder={'Onward'}
                    size={'sm'}
                    styleConfig={{
                        rootBox: {
                            className: gapClassName
                        },
                        root: {
                            css: { ...glassFieldCss, ...fieldCss }
                        }
                    }}
                    textTypographyProps={textVariant ? { variant: textVariant } : undefined}
                    value={formatDate(range.from)}
                    width={fieldWidth}
                    onClick={handleOnwardClick}
                />
                <TextField
                    name="to"
                    placeholder={'Return'}
                    size={'sm'}
                    styleConfig={{
                        rootBox: {
                            className: gapClassName
                        },
                        root: {
                            css: { ...glassFieldCss, ...fieldCss }
                        }
                    }}
                    suffix={formatDate(range.to) ? returnCrossJsx : <></>}
                    textTypographyProps={textVariant ? { variant: textVariant } : undefined}
                    value={formatDate(range.to)}
                    width={fieldWidth}
                    onClick={handleReturnClick}
                />
                <DropdownMenu
                    className="t-52 br-12"
                    distance={0}
                    offset={-258}
                    open={openCalendar}
                    width={764}
                >
                    <Container className="flex px-3 py-4 flex-middle flex-between bg-neutral-300">
                        <Container className="flex flex-center flex-middle flex-1" style={{ marginLeft: '22%' }}>
                            {activeReturn ? (
                                <Typography className="calendar-txt-zoom-in" variant="B1">
                                    {'Return'}
                                </Typography>
                            ) : (
                                <Typography variant="B1">{'Onward'}</Typography>
                            )}
                            {activeReturn ? (
                                !isEmpty(onwardJourny) && !isEmpty(returnJourny) ? (
                                    <Typography className="px-3" color="subheading" variant="P1">
                                        {returnJourny} {isRtl ? ' ← ' : ' → '} {onwardJourny}
                                    </Typography>
                                ) : (
                                    ''
                                )
                            ) : !isEmpty(onwardJourny) && !isEmpty(returnJourny) ? (
                                <Typography className="px-3" color="subheading" variant="P1">
                                    {onwardJourny} {isRtl ? ' ← ' : ' → '} {returnJourny}
                                </Typography>
                            ) : (
                                ''
                            )}
                        </Container>
                        <Container className="flex flex-end flex-middle">
                            <Typography colorCode="#999" variant="P3">
                                {'All fares shown are in ₹'}
                            </Typography>
                        </Container>
                    </Container>
                    <Spacer className="pt-5" />
                    <Calendar
                        activeOnward={activeOnward}
                        activeReturn={activeReturn}
                        className="w-100p"
                        directionClick={directionClick}
                        fareCalendar={fareCalendar}
                        index={index}
                        isCFW={isCFW}
                        isMulticity={isMulticity}
                        isRtl={isRtl}
                        multiCityDestinations={multiCityDestinations}
                        roundTrip={roundTrip}
                        selectedDates={range}
                        showDateFare={showDateFare}
                        title="New Delhi → Bengaluru"
                        onClickCalendar={setDates}
                    />
                </DropdownMenu>
                {!isEmpty(openCalendar) &&
                    ReactDOM.createPortal(<Overlay customOverlayWrapperClass="z-20" />, document.body)}
            </div>
        </OutsideClickHandler>
    )
}

export default CalendarWrapper
